import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import helloImage from '../assets/hello.png';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
// Коллекция 1 - изображения
import col1_img1 from '../assets/col1_img1.jpg';
import col1_img2 from '../assets/col1_img2.jpg';
import col1_img3 from '../assets/col1_img3.jpg';
import col1_img4 from '../assets/col1_img4.jpg';
import col1_img5 from '../assets/col1_img5.jpg';
import col1_img6 from '../assets/col1_img6.jpg';
import col1_img7 from '../assets/col1_img7.jpg';
import col1_img8 from '../assets/col1_img8.jpg';
import col1_background from '../assets/col1_background.jpg';
// Коллекция 2 - изображения
import col2_img1 from '../assets/col2_img1.jpg';
import col2_img2 from '../assets/col2_img2.jpg';
import col2_img3 from '../assets/col2_img3.jpg';
import col2_img4 from '../assets/col2_img4.jpg';
import col2_img5 from '../assets/col2_img5.jpg';
import col2_img6 from '../assets/col2_img6.jpg';
import col2_img7 from '../assets/col2_img7.jpg';
import col2_img8 from '../assets/col2_img8.jpg';
import col2_img9 from '../assets/col2_img9.jpg';
import col2_background from '../assets/col2_background.jpg';
// Коллекция 3 - изображения
import col3_img1 from '../assets/col3_img1.jpg';
import col3_background from '../assets/col3_background.jpg';
// Коллекция 4 - изображения
import col4_img1 from '../assets/col4_img1.jpg';
import col4_img2 from '../assets/col4_img2.jpg';
import col4_img3 from '../assets/col4_img3.jpg';
import col4_img4 from '../assets/col4_img4.jpg';
import col4_img5 from '../assets/col4_img5.jpg';
import col4_img6 from '../assets/col4_img6.jpg';
import col4_img7 from '../assets/col4_img7.jpg';
import col4_img8 from '../assets/col4_img8.jpg';
import col4_background from '../assets/col4_background.jpg';
// Коллекция 5 - изображения
import col5_img1 from '../assets/col5_img1.jpg';
import col5_background from '../assets/col5_background.jpg';
// Коллекция 6 - изображения
import col6_img1 from '../assets/col6_img1.jpg';
import col6_img2 from '../assets/col6_img2.jpg';
import col6_img3 from '../assets/col6_img3.jpg';
import col6_img4 from '../assets/col6_img4.jpg';
import col6_img5 from '../assets/col6_img5.jpg';
import col6_img6 from '../assets/col6_img6.jpg';
import col6_background from '../assets/col6_background.jpg';

import wonder from '../assets/col5_background.jpg';
import newsimage from '../assets/NewsImage.png';
import newsMin1 from '../assets/123.png';
import newsMin2 from '../assets/1234.png';
import newsMin3 from '../assets/124.png';
import newsMin4 from '../assets/125.png';
import topSecImage from '../assets/TopSec.png';

import col1 from '../assets/col1_img1.jpg';
import col2 from '../assets/col2_img1.jpg';
import col3 from '../assets/col3_img1.jpg';
import col4 from '../assets/col4_img1.jpg';

export default function MainPage() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const carouselRef = useRef(null);
  const sectionRef = useRef(null);
  const animationRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  // Состояние для изображений коллекций
  const [collectionImages, setCollectionImages] = useState({
    'cyberpank': [],
    'myth-cats': [],
    'energy-near-you': [],
    'spirits-above': []
  });

  // Ref для хранения актуальных изображений (для использования в интервале)
  const collectionImagesRef = useRef({
    'cyberpank': [],
    'myth-cats': [],
    'energy-near-you': [],
    'spirits-above': []
  });

  // Ref для хранения текущих URL изображений (для использования в интервале)
  const currentImageUrlsRef = useRef({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Состояние для текущих индексов изображений каждой коллекции
  const [currentImageIndex, setCurrentImageIndex] = useState({
    'cyberpank': 0,
    'myth-cats': 0,
    'energy-near-you': 0,
    'spirits-above': 0
  });

  // Состояние для текущих URL изображений (для принудительного обновления)
  const [currentImageUrls, setCurrentImageUrls] = useState({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Состояние для отслеживания анимации слайда
  const [slideDirection, setSlideDirection] = useState({
    'cyberpank': 'idle',
    'myth-cats': 'idle',
    'energy-near-you': 'idle',
    'spirits-above': 'idle'
  });

  // Состояние для предыдущих изображений (для анимации)
  const [previousImageUrls, setPreviousImageUrls] = useState({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Ref для предыдущих изображений (для использования в интервале)
  const previousImageUrlsRef = useRef({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  const maxScroll = -((400 + 20) * 6 - 1661);

  // Загрузка изображений коллекций из БД
  useEffect(() => {
    const fetchCollectionImages = async () => {
      const collectionSlugs = ['cyberpank', 'myth-cats', 'energy-near-you', 'spirits-above'];
      
      // Определяем, локально ли мы работаем (с проверкой на существование window)
      const isLocal = typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' || 
        window.location.hostname === '127.0.0.1' || 
        window.location.hostname.startsWith('192.168.')
      );
      
      // Для локальной разработки используем импортированные изображения
      if (isLocal) {
        console.log('🔧 Локальный режим: используем импортированные изображения');
        const staticImages = {
          'cyberpank': [
            col1_img1,
            col1_img2,
            col1_img3,
            col1_img4,
            col1_img5,
            col1_img6,
            col1_img7,
            col1_img8
          ],
          'myth-cats': [
            col2_img1,
            col2_img2,
            col2_img3,
            col2_img4,
            col2_img5,
            col2_img6,
            col2_img7,
            col2_img8,
            col2_img9
          ],
          'energy-near-you': [
            col6_img1,
            col6_img2,
            col6_img3,
            col6_img4,
            col6_img5,
            col6_img6
          ],
          'spirits-above': [
            col4_img1,
            col4_img2,
            col4_img3,
            col4_img4,
            col4_img5,
            col4_img6,
            col4_img7,
            col4_img8
          ]
        };
        
        setCollectionImages(staticImages);
        collectionImagesRef.current = staticImages;
        
        const initialUrls = {
          'cyberpank': staticImages['cyberpank'][0] || col1,
          'myth-cats': staticImages['myth-cats'][0] || col2,
          'energy-near-you': staticImages['energy-near-you'][0] || col3,
          'spirits-above': staticImages['spirits-above'][0] || col4
        };
        setCurrentImageUrls(initialUrls);
        setPreviousImageUrls(initialUrls);
        currentImageUrlsRef.current = initialUrls;
        previousImageUrlsRef.current = initialUrls;
        console.log('🖼️ Установлены импортированные изображения. Количество:', {
          'cyberpank': staticImages['cyberpank'].length,
          'myth-cats': staticImages['myth-cats'].length,
          'energy-near-you': staticImages['energy-near-you'].length,
          'spirits-above': staticImages['spirits-above'].length
        });
        return;
      }
      
      // Для production используем API, но если API недоступен, используем fallback на статические изображения
      console.log('🌐 Production режим: загружаем изображения из API');
      
      try {
        const promises = collectionSlugs.map(async (slug) => {
          try {
            const apiUrl = `/api/collections/${slug}`;
            console.log(`📡 Запрос к API: ${apiUrl}`);
            
            const response = await fetch(apiUrl);
            
            // Проверяем, что ответ JSON, а не HTML
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
              console.warn(`⚠️ Получен не JSON ответ для ${slug}:`, contentType);
              return { slug, images: [] };
            }
            
            if (response.ok) {
              const data = await response.json();
              // Извлекаем изображения из NFT
              const images = data.collection?.nfts?.map(nft => nft.imagelink) || [];
              console.log(`✅ Загружены изображения для ${slug}:`, images.length, 'штук');
              return { slug, images };
            } else {
              console.warn(`⚠️ Не удалось загрузить коллекцию ${slug}:`, response.status);
            }
          } catch (error) {
            console.error(`❌ Ошибка загрузки коллекции ${slug}:`, error);
          }
          return { slug, images: [] };
        });

        const results = await Promise.all(promises);
        const imagesMap = {};
        results.forEach(({ slug, images }) => {
          imagesMap[slug] = images;
        });

        // Проверяем, есть ли хотя бы одно изображение
        const hasAnyImages = Object.values(imagesMap).some(images => images && images.length > 0);
        
        // Если все массивы пустые, используем fallback изображения
        if (!hasAnyImages) {
          console.warn('⚠️ API не вернул изображения, используем fallback');
          const fallbackImages = {
            'cyberpank': [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
            'myth-cats': [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
            'energy-near-you': [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
            'spirits-above': [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8]
          };
          setCollectionImages(fallbackImages);
          collectionImagesRef.current = fallbackImages;
          const fallbackUrls = {
            'cyberpank': fallbackImages['cyberpank'][0] || col1,
            'myth-cats': fallbackImages['myth-cats'][0] || col2,
            'energy-near-you': fallbackImages['energy-near-you'][0] || col3,
            'spirits-above': fallbackImages['spirits-above'][0] || col4
          };
          setCurrentImageUrls(fallbackUrls);
          setPreviousImageUrls(fallbackUrls);
          currentImageUrlsRef.current = fallbackUrls;
          previousImageUrlsRef.current = fallbackUrls;
          return;
        }

        console.log('📦 Загруженные изображения:', imagesMap);
        setCollectionImages(imagesMap);
        // Обновляем ref для использования в интервале
        collectionImagesRef.current = imagesMap;
        
        // Устанавливаем первые изображения для каждой коллекции (с fallback)
        const initialUrls = {
          'cyberpank': imagesMap['cyberpank']?.[0] || col1_img1 || col1,
          'myth-cats': imagesMap['myth-cats']?.[0] || col2_img1 || col2,
          'energy-near-you': imagesMap['energy-near-you']?.[0] || col6_img1 || col3,
          'spirits-above': imagesMap['spirits-above']?.[0] || col4_img1 || col4
        };
        setCurrentImageUrls(initialUrls);
        setPreviousImageUrls(initialUrls);
        currentImageUrlsRef.current = initialUrls;
        previousImageUrlsRef.current = initialUrls;
        console.log('🖼️ Установлены начальные изображения:', initialUrls);
      } catch (error) {
        console.error('❌ Ошибка загрузки коллекций:', error);
        // Fallback: используем импортированные изображения, если API недоступен
        console.log('🔄 Используем fallback изображения из-за ошибки API');
        const fallbackImages = {
          'cyberpank': [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
          'myth-cats': [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
          'energy-near-you': [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
          'spirits-above': [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8]
        };
        setCollectionImages(fallbackImages);
        collectionImagesRef.current = fallbackImages;
        const fallbackUrls = {
          'cyberpank': fallbackImages['cyberpank'][0] || col1,
          'myth-cats': fallbackImages['myth-cats'][0] || col2,
          'energy-near-you': fallbackImages['energy-near-you'][0] || col3,
          'spirits-above': fallbackImages['spirits-above'][0] || col4
        };
        setCurrentImageUrls(fallbackUrls);
        setPreviousImageUrls(fallbackUrls);
        currentImageUrlsRef.current = fallbackUrls;
      }
    };

    fetchCollectionImages();
  }, []);

  // Ref для хранения таймеров каждой коллекции
  const rotationTimersRef = useRef({});

  // Функция для получения случайной задержки от 4 до 9 секунд
  const getRandomDelay = () => {
    return 4000 + Math.random() * 5000; // От 4000 до 9000 мс
  };

  // Функция для переключения изображения одной коллекции
  const rotateCollectionImage = useCallback((slug) => {
    const currentImages = collectionImagesRef.current[slug];
    if (!currentImages || currentImages.length === 0) {
      return;
    }

    setCurrentImageIndex((prev) => {
      const currentIndex = prev[slug] !== undefined ? prev[slug] : 0;
      const nextIndex = (currentIndex + 1) % currentImages.length;
      const imageUrl = currentImages[nextIndex];
      const currentUrl = currentImageUrlsRef.current[slug];
      
      if (!imageUrl || imageUrl === currentUrl) {
        return { ...prev, [slug]: nextIndex };
      }

      console.log(`🔄 ${slug}: индекс ${currentIndex} -> ${nextIndex}`);

      // Сохраняем предыдущее изображение
      const previousUrl = currentUrl;
      const previousUrlsUpdate = { ...previousImageUrlsRef.current };
      previousUrlsUpdate[slug] = previousUrl;
      
      setPreviousImageUrls(previousUrlsUpdate);
      previousImageUrlsRef.current = previousUrlsUpdate;

      // Устанавливаем новое изображение
      const newUrls = { ...currentImageUrlsRef.current };
      newUrls[slug] = imageUrl;
      setCurrentImageUrls(newUrls);
      currentImageUrlsRef.current = newUrls;

      // Запускаем анимацию
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            setSlideDirection((prevDir) => ({
              ...prevDir,
              [slug]: 'sliding'
            }));
            console.log(`🖼️ Запущена анимация слайда для: ${slug}`);
            
            // После завершения анимации сбрасываем состояние
            setTimeout(() => {
              setSlideDirection((prevDir) => ({
                ...prevDir,
                [slug]: 'idle'
              }));
              
              // Обновляем previousImageUrls
              const finalPreviousUrls = { ...previousImageUrlsRef.current };
              finalPreviousUrls[slug] = imageUrl;
              setPreviousImageUrls(finalPreviousUrls);
              previousImageUrlsRef.current = finalPreviousUrls;
              
              console.log(`✅ Анимация завершена для ${slug}`);
            }, 600); // Длительность анимации
          }, 100); // Задержка перед началом анимации
        });
      });

      return { ...prev, [slug]: nextIndex };
    });
  }, []);

  // Функция для планирования следующего переключения коллекции
  const scheduleNextRotation = useCallback((slug) => {
    // Очищаем предыдущий таймер для этой коллекции
    if (rotationTimersRef.current[slug]) {
      clearTimeout(rotationTimersRef.current[slug]);
    }

    const delay = getRandomDelay();
    console.log(`⏰ Запланировано переключение ${slug} через ${Math.round(delay)}мс`);

    rotationTimersRef.current[slug] = setTimeout(() => {
      rotateCollectionImage(slug);
      // Планируем следующее переключение
      scheduleNextRotation(slug);
    }, delay);
  }, [rotateCollectionImage]);

  // Ротация изображений с случайными задержками от 4 до 9 секунд
  useEffect(() => {
    // Проверяем, есть ли хотя бы одна коллекция с изображениями
    const hasImages = Object.values(collectionImages).some(images => images.length > 0);
    
    if (!hasImages) {
      console.log('⏸️ Ротация не запущена: нет изображений. collectionImages:', collectionImages);
      return;
    }

    console.log('▶️ Запуск ротации изображений со случайными задержками (4-9 сек)');
    console.log('📦 Текущие изображения:', collectionImagesRef.current);

    // Запускаем ротацию для каждой коллекции с начальной случайной задержкой
    const collectionSlugs = Object.keys(collectionImagesRef.current);
    collectionSlugs.forEach((slug) => {
      const images = collectionImagesRef.current[slug];
      if (images && images.length > 1) {
        // Каждая коллекция начинает переключаться с разной задержкой
        const initialDelay = getRandomDelay();
        console.log(`🚀 Запуск ротации для ${slug} с начальной задержкой ${Math.round(initialDelay)}мс`);
        
        rotationTimersRef.current[slug] = setTimeout(() => {
          rotateCollectionImage(slug);
          scheduleNextRotation(slug);
        }, initialDelay);
      }
    });

    return () => {
      console.log('⏹️ Остановка ротации изображений');
      // Очищаем все таймеры
      Object.values(rotationTimersRef.current).forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
      rotationTimersRef.current = {};
    };
  }, [collectionImages, rotateCollectionImage, scheduleNextRotation]);

  // Функция для получения текущего изображения коллекции
  const getCurrentImage = useCallback((slug, fallbackImage) => {
    // Используем состояние currentImageUrls для гарантированного обновления
    const currentUrl = currentImageUrls[slug];
    if (currentUrl) {
      return currentUrl;
    }
    
    // Fallback на вычисление из состояния
    const images = collectionImages[slug] || [];
    if (images.length > 0) {
      const index = currentImageIndex[slug] !== undefined ? currentImageIndex[slug] : 0;
      const imageUrl = images[index];
      if (!imageUrl) {
        return fallbackImage;
      }
      return imageUrl;
    }
    return fallbackImage;
  }, [collectionImages, currentImageIndex, currentImageUrls]);

  // Функция для рендеринга изображения со слайд-анимацией
  const renderSlidingImage = useCallback((slug, fallbackImage, style, onError) => {
    const currentImage = getCurrentImage(slug, fallbackImage);
    const previousImage = previousImageUrls[slug] || fallbackImage;
    const isSliding = slideDirection[slug] === 'sliding';
    const imagesAreDifferent = currentImage !== previousImage;
    
    // Извлекаем border из style для применения к контейнеру
    const { border, ...containerStyle } = style;
    const imageBorder = border || '4px solid #FE0000';
    
    // Если изображения одинаковые и не идет анимация, показываем только одно
    if (!imagesAreDifferent && !isSliding) {
      return (
        <div
          className="absolute"
          style={{
            ...containerStyle,
            overflow: 'hidden',
            zIndex: style.zIndex || 5,
            border: imageBorder
          }}
        >
          <img
            key={`${slug}-static-${currentImage}`}
            src={currentImage}
            alt={slug}
            className="absolute"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              top: 0,
              left: 0
            }}
            onError={onError}
          />
        </div>
      );
    }
    
    // Определяем позиции для анимации
    // Новое изображение всегда начинается справа (100%), если изображения разные
    // При анимации оно перемещается в центр (0%)
    const newImagePosition = imagesAreDifferent 
      ? (isSliding ? '0%' : '100%')  // Если разные: справа до анимации, в центре во время анимации
      : '0%';  // Если одинаковые: всегда в центре
    
    // Предыдущее изображение находится в центре (0%), при анимации уезжает влево (-100%)
    const prevImagePosition = isSliding ? '-100%' : '0%';
    
    // Если изображения разные или идет анимация, показываем оба слоя
    return (
      <div
        className="absolute"
        style={{
          ...containerStyle,
          overflow: 'hidden',
          zIndex: style.zIndex || 5,
          border: imageBorder
        }}
      >
        {/* Предыдущее изображение (уезжает влево при анимации) */}
        <img
          key={`${slug}-prev-${previousImage}`}
          src={previousImage}
          alt={`${slug} previous`}
          className="absolute"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `translateX(${prevImagePosition})`,
            transition: isSliding ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'none',
            top: 0,
            left: 0,
            zIndex: 1
          }}
          onError={onError}
        />
        
        {/* Новое/текущее изображение (выезжает справа при анимации) */}
        <img
          key={`${slug}-current-${currentImage}`}
          src={currentImage}
          alt={slug}
          className="absolute"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `translateX(${newImagePosition})`,
            transition: isSliding ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'transform 0s linear',
            top: 0,
            left: 0,
            zIndex: 2,
            willChange: 'transform'
          }}
          onError={onError}
        />
      </div>
    );
  }, [getCurrentImage, previousImageUrls, slideDirection]);

  const handleMouseEnter = () => {
    setIsScrolling(true);
  };

  const handleMouseLeave = () => {
    setIsScrolling(false);
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
  };

  const handleMouseMove = useCallback((e) => {
    if (!isScrolling || !sectionRef.current) return;

    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }

    animationRef.current = requestAnimationFrame(() => {
      const section = sectionRef.current;
      const rect = section.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const sectionWidth = rect.width;
      const leftZone = sectionWidth * 0.2;
      const rightZone = sectionWidth * 0.8;

      let targetScroll = scrollPosition;

      if (mouseX < leftZone) {
        targetScroll = Math.min(0, scrollPosition + 3);
      } else if (mouseX > rightZone) {
        targetScroll = Math.max(maxScroll, scrollPosition - 3);
      }

      setScrollPosition(targetScroll);
    });
  }, [isScrolling, scrollPosition, maxScroll]);

  // Проверка, лайкнута ли коллекция
  const isCollectionLiked = (slug) => {
    // Если пользователь не залогинен, всегда возвращаем false
    if (!user) {
      return false;
    }
    // Если у пользователя нет массива коллекций, возвращаем false
    if (!Array.isArray(user.collections)) {
      return false;
    }
    return user.collections.some((col) => col.slug === slug);
  };

  // Массив данных коллекций с разными изображениями
  const collections = [
    {
      id: 'cyberpank',
      image: col1_img1,
      background: col1_background,
      route: '/collection/cyberpank',
      title: 'Cyberpank',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'myth-cats',
      image: col2_img1,
      background: col2_background,
      route: '/collection/myth-cats',
      title: 'Myth Cats',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'future-illusion',
      image: col3_img1,
      background: col3_background,
      route: '/collection/future-illusion',
      title: 'Future Illusion',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'spirits-above',
      image: col4_img1,
      background: col4_background,
      route: '/collection/spirits-above',
      title: 'Spirits Above',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'wonder',
      image: col5_img1,
      background: col5_background,
      route: '/collection/wonder',
      title: 'Wonder',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'energy-near-you',
      image: col6_img1,
      background: col6_background,
      route: '/collection/energy-near-you',
      title: 'Energy Near You',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 111,
      createdBy: 'Bojar',
      isLiked: false
    }
  ];

  return (
    <div className="h-screen bg-[#1E1E1E] text-white main-font flex flex-col overflow-hidden">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="main" />

        {/* Main Content */}
        <main className="flex-1 bg-[#1E1E1E] flex flex-col overflow-hidden">
          {/* Scrollable Content Area */}
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div style={{ maxWidth: '86.51vw', margin: '0' }}>
          {/* Top Section with TopSec background */}
          <div
            style={{
              backgroundImage: `url(${topSecImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              position: 'relative',
              paddingTop: 'clamp(20px, 1.88vw, 36px)',
              paddingBottom: 'clamp(20px, 2.08vw, 40px)',
              width: '100%'
            }}
          >
          {/* Collections Row Section */}
          <div 
              className="relative"
              style={{
                width: '100%',
                maxWidth: 'clamp(800px, 86.46vw, 1660px)',
                height: 'clamp(60px, 4.38vw, 84px)',
                backgroundColor: '#181818',
                marginTop: '0',
                display: 'flex',
                gap: 'clamp(30px, 3.18vw, 61px)',
                paddingLeft: 'clamp(40px, 5vw, 96px)',
                overflow: 'hidden'
              }}
            >
            {/* Collection Card 1 - Most Visited */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/future-illusion')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Most Visited Collection
              </div>
              
              <img 
                src={require('../assets/1.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Future Illusion
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Bojar
              </div>
            </div>

            {/* Collection Card 2 - New Top */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/myth-cats')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                New Top Collection
              </div>
              
              <img 
                src={require('../assets/2.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(24px, 1.88vw, 36px)',
                  height: 'clamp(13px, 1.04vw, 20px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(32px, 2.71vw, 52px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Myth Cats
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Luna
              </div>
            </div>

            {/* Collection Card 3 - Trending */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/future-illusion')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Trending
              </div>
              
              <img 
                src={require('../assets/3.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Future Illusion
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Bojar
              </div>
            </div>

            {/* Collection Card 4 - Ideal Relativian */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/spirits-above')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '90%'
                }}
              >
                 Week Redaction Choose
              </div>
              
              <img 
                src={require('../assets/4.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Spirits Above
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Five
              </div>
            </div>

            {/* Collection Card 5 - Today Art */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/cyberpank')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Today Art
              </div>
              
              <img 
                src={require('../assets/5.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Cyberpank
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Elsa
              </div>
            </div>

            {/* Divider */}
            <div 
              className="flex-shrink-0"
              style={{
                width: '1px',
                height: 'clamp(40px, 3.13vw, 60px)',
                backgroundColor: 'rgba(217, 217, 217, 0.6)',
                alignSelf: 'center'
              }}
            />

            {/* Группа: Hello NFT + полоска (без gap между ними) */}
            <div 
              className="flex-shrink-0"
              style={{
                display: 'flex',
                gap: 'clamp(4px, 0.42vw, 8px)', 
                height: '100%'
              }}
            >
              {/* Special Card - Hello NFT */}
              <div 
                className="flex-shrink-0 relative"
                style={{
                  width: 'clamp(140px, 9.9vw, 190px)',
                  height: '100%',
                  backgroundColor: '#5C6FFF'
                }}
              >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Best NFT Story
              </div>
              
              <img 
                src={helloImage}
                alt="Hello NFT"
                style={{
                  position: 'absolute',
                  left: 'clamp(12px, 0.99vw, 19px)',
                  top: 'clamp(21px, 1.72vw, 33px)',
                  width: 'clamp(26px, 2.08vw, 40px)',
                  height: 'clamp(26px, 2.08vw, 40px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(44px, 3.65vw, 70px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Hello NFT
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Five
              </div>
            </div>

            {/* Accent strip */}
            <div 
              className="flex-shrink-0"
              style={{
                width: 'clamp(30px, 2.05vw, 40px)',
                height: '100%',
                backgroundColor: 'rgba(92, 111, 255, 0.7)'
              }}
            />
          </div>
          </div>

          {/* eyes */}    
          <div 
            className="relative"
            style={{
              marginLeft: 'clamp(35px, 3.65vw, 70px)',
              marginTop: 'clamp(30px, 3.13vw, 60px)',
              width: 'clamp(390px, 40.68vw, 781px)',
              height: 'clamp(170px, 17.71vw, 340px)'
            }}
          >
            <div className="overflow-hidden" style={{ width: '100%', height: '100%' }}>
              <img 
                src={wonder}
                alt="Crypto InfiniG"
                className="transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                onClick={() => navigate('/collection/wonder')}
              />
            </div>
            
            {/* Wonder overlay frame */}
            <div
              className="absolute"
              style={{
                left: 'clamp(15px, 1.56vw, 30px)',
                top: 'clamp(106px, 11.09vw, 213px)',
                width: 'clamp(185px, 19.27vw, 370px)',
                height: 'clamp(55px, 5.73vw, 110px)',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                border: '1px solid #CC0000',
                borderRadius: '2px',
                padding: 'clamp(6px, 0.94vw, 12px) clamp(8px, 1.25vw, 16px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                pointerEvents: 'none'
              }}
            >
              <div
                style={{
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF',
                  marginBottom: 'clamp(3px, 0.31vw, 6px)'
                }}
              >
                Wonder
              </div>
              <div
                style={{
                  fontFamily: 'Inder',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.73vw, 14px)',
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: 1.3
                }}
              >
                The collection wonder world contains five parts<br />
                what represents a city of energy flowing above<br />
                houses and watching dreams of people.
              </div>
            </div>
            
            <div 
              className="absolute bg-[#1A1A1A]"
              style={{
                right: '0',
                top: '0',
                width: 'clamp(90px, 9.38vw, 180px)',
                height: '100%'
              }}
            >
              <div 
                className="absolute bg-[#CC0000] flex items-center justify-center"
                style={{
                  left: '0',
                  top: 'clamp(14px, 1.46vw, 28px)',
                  width: '100%',
                  height: 'clamp(19px, 1.98vw, 38px)'
                }}
              >
                <span 
                  style={{
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(8px, 0.83vw, 16px)',
                    color: '#FFFFFF'
                  }}
                >
                  Wonder
                </span>
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(48px, 5vw, 96px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(45.5px, 4.74vw, 91px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Items
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(69px, 7.19vw, 138px)',
                  top: 'clamp(45.5px, 4.74vw, 91px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                5
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(65.5px, 6.82vw, 131px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(63.5px, 6.61vw, 127px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Top price
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(62px, 6.46vw, 124px)',
                  top: 'clamp(63.5px, 6.61vw, 127px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1.4 sol
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(82px, 8.54vw, 164px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(79.5px, 8.28vw, 159px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Floor price
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(63px, 6.56vw, 126px)',
                  top: 'clamp(80px, 8.33vw, 160px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1.4 sol
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(99px, 10.31vw, 198px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(96.5px, 10.05vw, 193px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Listed
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(70.5px, 7.34vw, 141px)',
                  top: 'clamp(97px, 10.1vw, 194px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(116px, 12.08vw, 232px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(113.5px, 11.82vw, 227px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                By bojar
              </div>
            </div>

            {/* upcoming collections - внутри relative контейнера */}
            <div 
  className="absolute"
  style={{
    left: '43vw',
    top: '0vh',
    width: '17.45vw',
    height: '7.29vw',
    backgroundColor: '#1C1A1A'
  }}
>
  <div 
    style={{
      position: 'absolute',
      left: '3.96vw',
      top: '3.02vw',
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: '0.73vw',
      color: '#FFFFFF'
    }}
  >
    UPCOMING COLLECTITON'S
  </div>
  
  <div 
    style={{
      position: 'absolute',
      left: '3.07vw',
      top: '4.48vw',
      width: '11.35vw',
      height: '0.1vw',
      backgroundColor: '#CC0000'
    }}
  >
    <div 
      style={{
        position: 'absolute',
        right: '-0.52vw',
        top: '-0.21vw',
        width: '0',
        height: '0',
        borderLeft: '0.52vw solid #CC0000',
        borderTop: '0.26vw solid transparent',
        borderBottom: '0.26vw solid transparent'
      }}
    />
  </div>
</div>

<div 
  className="absolute"
  style={{
    left: '43vw',
    top: '16vh',
    width: '17.45vw',
    height: '7.29vw',
    backgroundColor: '#1C1A1A'
  }}
>
  <p 
    style={{
      position: 'absolute',
      left: '1.41vw',
      top: '2.55vw',
      right: '1.51vw',
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: '0.63vw',
      color: '#FFFFFF',
      opacity: 0.66,
      lineHeight: '1.4',
      width: 'calc(100% - 1.92vw)'
    }}
  >
    Some not a wise words, wile it not wise you think some things and there is someone not snowboarding enough.
  </p>
</div>

{renderSlidingImage('cyberpank', col1, {
    left: '62.5vw',
    top: '-0.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000',
    zIndex: 5
  }, (e) => {
    console.error('❌ Ошибка загрузки изображения CyberPunk:', e.target.src);
    e.target.onerror = null;
    e.target.src = col1;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(62.5vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(-0.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    CyberPunk
  </span>
</div>

{renderSlidingImage('myth-cats', col2, {
    left: '72.2vw',
    top: '-0.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col2;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(72.2vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(-0.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Myth Cats
  </span>
</div>

{renderSlidingImage('energy-near-you', col3, {
    left: '62.5vw',
    top: '20.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col3;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(62.5vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(20.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Energy Near
  </span>
</div>

{renderSlidingImage('spirits-above', col4, {
    left: '72.2vw',
    top: '20.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col4;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(72.2vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(20.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Spirits Above you
  </span>
</div>
          </div>
          </div>

          {/* news */}  
          <div className="relative">
            <div 
              style={{
                width: 'clamp(830.5px, 86.51vw, 1661px)',
                height: 'clamp(5.5px, 0.57vw, 11px)',
                backgroundColor: '#520001'
              }}
            />
            
            <div 
              className="bg-[#141414] flex items-center justify-center"
              style={{
                width: 'clamp(65px, 6.77vw, 130px)',
                height: 'clamp(25px, 2.6vw, 50px)',
                marginTop: '0'
              }}
            >
              <span 
                style={{
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(9px, 0.94vw, 18px)',
                  color: '#FFFFFF'
                }}
              >
                New's
              </span>
            </div>

            <div 
              className="absolute cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/news/1')}
              style={{
                left: 'clamp(35px, 3.65vw, 70px)',
                top: 'clamp(39px, 4.06vw, 78px)',
                width: 'clamp(467.5px, 48.7vw, 935px)',
                height: 'clamp(230px, 23.96vw, 460px)'
              }}
            >
              <img 
                src={newsimage}
                alt="Nike"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  border: '1px solid #FE0000',
                  borderRadius: '6px',
                  boxShadow: '0 0 14px 16px rgba(0, 0, 0, 0.25)',
                  filter: 'url(#noiseFilter)'
                }}
              />
              
              <div 
                className="absolute"
                style={{
                  left: 'clamp(226px, 23.54vw, 452px)',
                  bottom: 'clamp(20px, 2.08vw, 40px)',
                  width: 'clamp(225px, 23.44vw, 450px)',
                  height: 'clamp(55px, 5.73vw, 110px)',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  borderRadius: '4px'
                }}
              >
                <div 
                  style={{
                    position: 'absolute',
                    left: 'clamp(5px, 0.52vw, 10px)',
                    top: 'clamp(5px, 0.52vw, 10px)',
                    width: 'clamp(200.5px, 20.26vw, 400px)',
                    height: 'clamp(11.5px, 1.2vw, 23px)',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(9.5px, 0.99vw, 19px)',
                    color: '#FFFFFF',
                    opacity: 0.9
                  }}
                >
                  What does the Future Hold for NFTs?
                </div>
                
                <div 
                  style={{
                    position: 'absolute',
                    left: 'clamp(5px, 0.52vw, 10px)',
                    top: 'clamp(22.5px, 2.34vw, 45px)',
                    width: 'clamp(196px, 20.42vw, 392px)',
                    height: 'clamp(19px, 1.98vw, 38px)',
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(7px, 0.73vw, 14px)',
                    color: '#FFFFFF',
                    opacity: 0.8,
                    lineHeight: '1.2'
                  }}
                >
                  NFTs are evolving from collectibles to practical tools. Discover how gaming, AI, and real-world tokenization are shaping the future of digital ownership through 2030.
                </div>
              </div>
            </div>

            <div 
              className="absolute bg-[#1A1A1A]"
              style={{
                left: 'clamp(520.5px, 54.22vw, 1041px)',
                top: 'clamp(41.5px, 4.32vw, 83px)',
                width: 'clamp(288.5px, 30.05vw, 577px)',
                height: 'clamp(225px, 23.44vw, 450px)'
              }}
            >
              <div 
                className="absolute flex cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => navigate('/news/2')}
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(19.5px, 2.03vw, 39px)',
                  width: 'clamp(250px, 26.04vw, 500px)',
                  height: 'clamp(40px, 4.17vw, 80px)',
                  gap: 'clamp(8px, 0.83vw, 16px)'
                }}
              >
                <img 
                  src={newsMin1}
                  alt="News 1"
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(40px, 4.17vw, 80px)',
                    objectFit: 'cover'
                  }}
                />
                
                <div 
                  className="bg-[#202020] flex items-center"
                  style={{
                    flex: 1,
                    height: 'clamp(40px, 4.17vw, 80px)',
                    paddingLeft: 'clamp(8px, 0.83vw, 16px)',
                    paddingRight: 'clamp(8px, 0.83vw, 16px)'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: '#FFFFFF',
                      opacity: 0.66
                    }}
                  >
                    Discover how AI-powered NFTs create intelligent, evolving digital assets that redefine creativity, ownership, and value in 2025 and beyond.
                  </span>
                </div>
              </div>

              <div 
                className="absolute flex cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => navigate('/news/3')}
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(68px, 7.08vw, 136px)',
                  width: 'clamp(250px, 26.04vw, 500px)',
                  height: 'clamp(40px, 4.17vw, 80px)',
                  gap: 'clamp(8px, 0.83vw, 16px)'
                }}
              >
                <img 
                  src={newsMin2}
                  alt="News 2"
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(40px, 4.17vw, 80px)',
                    objectFit: 'cover'
                  }}
                />
                
                <div 
                  className="bg-[#202020] flex items-center"
                  style={{
                    flex: 1,
                    height: 'clamp(40px, 4.17vw, 80px)',
                    paddingLeft: 'clamp(8px, 0.83vw, 16px)',
                    paddingRight: 'clamp(8px, 0.83vw, 16px)'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: '#FFFFFF',
                      opacity: 0.66
                    }}
                  >
                    Discover how fractional NFTs let investors share ownership of digital assets, boosting liquidity, accessibility, and innovation in NFT markets.
                  </span>
                </div>
              </div>

              <div 
                className="absolute flex cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => navigate('/news/4')}
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(116.5px, 12.14vw, 233px)',
                  width: 'clamp(250px, 26.04vw, 500px)',
                  height: 'clamp(40px, 4.17vw, 80px)',
                  gap: 'clamp(8px, 0.83vw, 16px)'
                }}
              >
                <img 
                  src={newsMin3}
                  alt="News 3"
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(40px, 4.17vw, 80px)',
                    objectFit: 'cover'
                  }}
                />
                
                <div 
                  className="bg-[#202020] flex items-center"
                  style={{
                    flex: 1,
                    height: 'clamp(40px, 4.17vw, 80px)',
                    paddingLeft: 'clamp(8px, 0.83vw, 16px)',
                    paddingRight: 'clamp(8px, 0.83vw, 16px)'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: '#FFFFFF',
                      opacity: 0.66
                    }}
                  >
                    Explore how NFT rarity still drives value in 2025—through psychology, identity, and storytelling—not hype. Learn why digital scarcity still matters.
                  </span>
                </div>
              </div>

              <div 
                className="absolute flex cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => navigate('/news/5')}
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(165px, 17.19vw, 330px)',
                  width: 'clamp(250px, 26.04vw, 500px)',
                  height: 'clamp(40px, 4.17vw, 80px)',
                  gap: 'clamp(8px, 0.83vw, 16px)'
                }}
              >
                <img 
                  src={newsMin4}
                  alt="News 4"
                  style={{
                    width: 'clamp(70px, 7.29vw, 140px)',
                    height: 'clamp(40px, 4.17vw, 80px)',
                    objectFit: 'cover'
                  }}
                />
                
                <div 
                  className="bg-[#202020] flex items-center"
                  style={{
                    flex: 1,
                    height: 'clamp(40px, 4.17vw, 80px)',
                    paddingLeft: 'clamp(8px, 0.83vw, 16px)',
                    paddingRight: 'clamp(8px, 0.83vw, 16px)'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(7px, 0.73vw, 14px)',
                      color: '#FFFFFF',
                      opacity: 0.66
                    }}
                  >
                    Learn how Decentralized Education reshapes learning with Web3, NFTs, and DAOs: enabling transparent credentials, peer-driven governance, and global access.
                  </span>
                </div>
              </div>
            </div>

            <div 
              style={{
                width: 'clamp(830.5px, 86.51vw, 1661px)',
                height: 'clamp(5.5px, 0.57vw, 11px)',
                backgroundColor: '#520001',
                marginTop: 'clamp(265px, 27.6vw, 530px)'
              }}
            />
          </div>

          {/* collection */}    
          <div 
            ref={sectionRef}
            className="mb-8 overflow-hidden relative"
            style={{
              width: 'clamp(830.5px, 86.51vw, 1661px)',
              height: 'clamp(155.5px, 16.96vw, 306px)',
              marginTop: 'clamp(20px, 2.08vw, 40px)',
              marginBottom: 'clamp(2px, 0.10vw, 2px)',
              marginLeft: 'clamp(22px, 2.29vw, 44px)'
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
          >
            <div 
              ref={carouselRef}
              className="flex transition-transform duration-100 ease-out"
              style={{ 
                transform: `translateX(${scrollPosition}px)`,
                gap: 'clamp(10px, 1.04vw, 20px)'
              }}
            >
              {collections.map((collection, index) => (
                <div 
                  key={collection.id}
                  onClick={() => navigate(collection.route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ 
                    width: 'clamp(200px, 20.83vw, 400px)', 
                    height: 'clamp(130px, 13.54vw, 260px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                  }}
                >
                  <div 
                    className="absolute z-10 flex items-center justify-center"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(32px, 3.33vw, 64px)',
                      height: 'clamp(21px, 2.19vw, 42px)',
                      backgroundColor: 'rgba(20, 20, 20, 0.6)'
                    }}
                  >
                    <img 
                      src={isCollectionLiked(collection.id) ? require('../assets/Like_icon.png') : require('../assets/unLike_icon.png')}
                      alt="Like"
                      style={{
                        width: 'clamp(17px, 1.77vw, 34px)',
                        height: 'clamp(17px, 1.77vw, 34px)'
                      }}
                    />
                  </div>
                  <div 
                    className="bg-black overflow-hidden" 
                    style={{ 
                      width: 'clamp(130px, 13.54vw, 260px)', 
                      height: 'clamp(130px, 13.54vw, 260px)' 
                    }}
                  >
                    <img 
                      src={collection.image} 
                      alt="Collection"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  <div 
                    className="flex flex-col justify-between text-center relative"
                    style={{ 
                      width: 'clamp(70px, 7.29vw, 140px)', 
                      height: 'clamp(130px, 13.54vw, 260px)',
                      backgroundColor: 'rgba(18, 20, 38, 1)',
                      border: '2px solid #9F191A',
                      padding: 'clamp(8px, 0.83vw, 16px)'
                    }}
                  >
                    <div 
                      className="text-white font-normal absolute flex items-center justify-center"
                      style={{
                        backgroundColor: '#9F191A',
                        top: 'clamp(10px, 1.04vw, 20px)',
                        left: '0',
                        width: 'clamp(70px, 7.29vw, 140px)',
                        height: 'clamp(13px, 1.35vw, 26px)',
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        lineHeight: '1',
                        opacity: 0.8
                      }}
                    >
                      {collection.title}
                    </div>
                    
                    <div 
                      className="space-y-2"
                      style={{ 
                        paddingTop: 'clamp(2.5px, 1.07vw, 20px)'
                      }}
                    >
                      <div style={{ marginTop: 'clamp(10.5px, 1.09vw, 21px)' }}>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          Collection Amount
                        </div>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(7px, 0.73vw, 14px)' }}
                        >
                          {collection.collectionAmount}
                        </div>
                      </div>
                      
                      <div style={{ marginTop: 'clamp(5px, 0.52vw, 10px)' }}>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          Best Offer
                        </div>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          {collection.bestOffer}
                        </div>
                      </div>
                      
                      <div style={{ marginTop: 'clamp(5px, 0.52vw, 10px)' }}>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          Followers
                        </div>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          {collection.followers}
                        </div>
                      </div>
                      
                      <div style={{ marginTop: 'clamp(5px, 0.52vw, 10px)' }}>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          Created By
                        </div>
                        <div 
                          className="text-white/80"
                          style={{ fontSize: 'clamp(6px, 0.63vw, 12px)' }}
                        >
                          {collection.createdBy}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          </div>
          </div>

          <Footer />
        </main>
      </div>
    </div>
  );
}